// @owner Workflows

export enum SettingsAgentTesterDataEventObjectsEnum {
  AGENT_TESTER_SET_ADD = 'agent_tester_set_add',
  AGENT_TESTER_RUN_ALL = 'agent_tester_run_all',
  AGENT_TESTER_SIMULATION_ADD = 'agent_tester_simulation_add',
  AGENT_TESTER_SIMULATION_SOURCE = 'agent_tester_simulation_source',
  AGENT_TESTER_SIMULATION_SOURCE_INBOX = 'agent_tester_simulation_source_inbox',
  AGENT_TESTER_SIMULATION_SOURCE_SELECT = 'agent_tester_simulation_source_select',
  AGENT_TESTER_SIMULATION_CONVERSATION_DETAILS = 'agent_tester_simulation_conversation_details',
  AGENT_TESTER_SIMULATION_CREATE = 'agent_tester_simulation_create',
  AGENT_TESTER_SIMULATION_SAVE = 'agent_tester_simulation_save',
  AGENT_TESTER_CRITERIA_SELECT = 'agent_tester_criteria_select',
  AGENT_TESTER_CRITERIA_GENERATE_SCALE = 'agent_tester_criteria_generate_scale',
  AGENT_TESTER_CRITERIA_CREATE = 'agent_tester_criteria_create',
  AGENT_TESTER_SIMULATION_EXPLORE = 'agent_tester_simulation_explore',
  AGENT_TESTER_SIMULATION_RESULTS = 'agent_tester_simulation_results',
  AGENT_TESTER_SIMULATION_RUN_VERSION = 'agent_tester_simulation_run_version',
}
